import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const ProductSalesReport = lazyWithRetry(() => import(/* webpackChunkName: "ProductSalesReport" */'../../component/OfficeReports/ProductSalesReport'))

const ProductSalesReportPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<ProductSalesReport />
		</Suspense>
	)
})

ProductSalesReportPage.displayName = 'ProductSalesReportPage'
export default ProductSalesReportPage
